import { useEffect, useState } from 'react';
import { SAMPLE_FILES } from '../data/sampleFiles';

var cache = null;

// Free sample downloads are assigned in the admin (Digital Files → Free sample
// files). Until one is set we fall back to the original static Dropbox link.
export function useSampleFiles() {
  var [samples, setSamples] = useState(cache);

  useEffect(function() {
    if (cache) return;
    var api = process.env.REACT_APP_BACKEND_URL;
    fetch(api + '/api/download/samples')
      .then(function(r) { return r.ok ? r.json() : { samples: {} }; })
      .then(function(d) { cache = d.samples || {}; setSamples(cache); })
      .catch(function() { cache = {}; setSamples(cache); });
  }, []);

  return function(platform) {
    var configured = samples && samples[platform];
    if (configured && configured.url) {
      return {
        url: process.env.REACT_APP_BACKEND_URL + configured.url,
        filename: configured.filename || SAMPLE_FILES[platform].filename,
      };
    }
    return { url: SAMPLE_FILES[platform].url, filename: SAMPLE_FILES[platform].filename };
  };
}
